import backend from './backendService';

class SwitchboardService {
  async getCalls() {
    return backend.get(`/calls`);
  }
}

export default new SwitchboardService();